<template>
  <ul
    class="dropdown__container"
    tabindex="0"
    v-if="visible"
    ref="dropdown"
    @focusin="focusIn"
    @focusout="focusOut"
    :class="large ? 'dropdown__container--large' : ''"
  >
    {{ valueUpdated(this.getSanitizedValue()) }}
    <p4a-input
      v-if="search && large"
      v-model="searchValue"
      :size="'large'"
      :leftIcon="'search'"
      class="dropdown__search"
      :placeholder="inputPlaceholder"
    ></p4a-input>
    <slot />
    <li
      v-if="amountOfOptionsVisible === 0"
      class="dropdown__item dropdown__item--empty"
    >
      {{ emptyText }}
    </li>
  </ul>
</template>

<script>
import Dropdown from '../../mixins/Dropdown'

export default {
  mixins: [
    Dropdown
  ],

  props: {
    large: {
      type: Boolean,
      default: false
    },

    emptyText: {
      type: String,
      default: 'Empty'
    },

    inputPlaceholder: {
      type: String,
      default: 'Zoeken...'
    },

    optionsAlign: {
      type: String,
      default: 'left'
    },

    optionsWidth: {
      type: String,
      default: 'auto'
    },

    optionsMinHeight: {
      type: String,
      default: '20px'
    },

    optionsHeight: {
      type: String,
      default: 'auto'
    },

    optionsMaxHeight: {
      type: String,
      default: '200px'
    }
  }
}
</script>

<style lang="scss">
  .dropdown-wrapper { position: relative; }
</style>

<style lang="scss" scoped>
  @import '../../styling/styling.scss';

  .dropdown {

    &__container {
      left: 0;
      @extend %shadow;
      position: absolute;
      display: inline-grid;
      border-radius: rem(2);
      background-color: $white;
      top: calc(100% + #{rem(3)});

      &--large {

        /deep/
        .dropdown__item {
          height: rem(50);
          line-height: rem(50);

          .p4a-icon {
            width: rem(50);
            height: rem(50);
            margin-right: 0;
            font-size: rem(18);
            margin-left: rem(-10);
          }

          .checkbox {
            width: rem(50);
            height: rem(50);
            float: left;
            display: block;
            margin: 0 0 0 rem(-10);

            &__check { left: rem(17); }
          }
        }
      }
    }

    /deep/
    &__item {
      height: rem(25);
      font-weight: 400;
      padding: 0 rem(10);
      font-size: rem(13);
      line-height: rem(25);
      color: $medium-grey-font;

      &:hover {
        cursor: pointer;
        color: $dark-grey-font;
        background-color: $light-grey-background;
      }

      &--icon {

        .p4a-icon {
          width: rem(16);
          height: rem(16);
          float: left;
          text-align: center;
          font-size: rem(16);
          margin-right: rem(10);
        }
      }

      &--multiple {

        .checkbox {
          display: unset;
          margin-right: rem(26);
        }
      }

      &:first-child {
        border-top-left-radius: rem(2);
        border-top-right-radius: rem(2);
      }

      &:last-child {
        border-bottom-left-radius: rem(2);
        border-bottom-right-radius: rem(2);
      }

      &--empty {
        font-style: italic;
        color: $light-grey-font;

        &:hover {
          cursor: not-allowed;
          color: $light-grey-font;
          background-color: $white;
        }
      }

      &--user {

        &-image {
          width: rem(30);
          height: rem(30);
          float: left;
          overflow: hidden;
          border-radius: 50%;
          margin: rem(10) rem(10) rem(10) 0;

          > img {
            width: 100%;
            height: 100%;
          }
        }

        .checkbox {
          float: left;
          display: unset;
          margin: rem(13) rem(27) rem(13) 0;
        }

        &-nae {
          line-height: rem(17)!important;

          .dropdown__item--user-name { margin-top: rem(7); }

          .dropdown__item--user-email { color: $light-grey-font; }
        }
      }
    }

    &__search {

      /deep/
      .input {
        border: 0;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        border-bottom: rem(1) solid $dark-grey-background;

        &:focus { border-color: $dark-grey-background; }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// node_modules/pro4all-ui/ui-kit/components/Dropdown/BaseDropdown.vue